import React from 'react'
import './ourprogress.scss'
import { Row, Col, } from 'react-bootstrap';
import {images} from '../../../utils/customFn';

const OurProgress = ({ data }) => {
    return (
        <>
            <div className='our-progress-wrapper'>
                <Row>
                    <Col sm={12} md={6} lg={8} xl={8}>
                        <div className='left-wrapper'>
                            <h2>2023 Annual Report</h2>
                            <button type="submit" class="downloadButton"><img src={images['download.svg']} alt='icon' /> Download</button>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={4} xl={4}>
                        <div className="right-side">
                            <div className="title">
                                <h3>Follow our progress</h3>
                            </div>
                            <ul className="icon-link-list">
                                {data.map((report) => (
                                    <li key={report.id} className="icon-link-item">
                                        <img src={report.icon} alt='icon' />
                                        <a href={report.link} className="link" target="_blank" rel="noopener noreferrer">
                                            <span>{report.name}</span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default OurProgress